export default __webpack_public_path__ + "static/media/amarachiCrystal.19c34396.jpeg";